'use strict'

import { loadComponent } from './utils/load-component';
import zonedDate from '../utils/zoned-date';
import { format } from 'date-fns';

loadComponent('concert', {
    props: {
        concert: {
            type: Object,
        },
    },

    data() {
        const date = zonedDate(this.concert.StartDate);

        return {
            ViewModel: {
                EventLink: this.concert.EventLink,
                Image: this.concert.Image,
                IsPast: this.concert.IsPast,
                Title: this.concert.Title,
                Prefix: this.concert.Prefix,
                Suffix: this.concert.Suffix,
                Venue: this.concert.Venue,
                Date: format(date, 'MMM d, yyyy'),
            },
        };
    },
});
